<template>
    <el-popover trigger="hover" placement="right" popper-class="c-el-popover-blue item-popover">
        <div
            slot="reference"
            class="list-item"
            :class="{ 'activity': activityId == data.id }"
            @click="handleClick(data)"
        >
            <div class="item-info">{{ data.name }}</div>
            <i class="iconfont icon-dingwei item-icon"></i>
        </div>
        <div>
            <hzItemDetailsPop :itemObj="data" :border="false" />
        </div>
    </el-popover>
</template>

<script>
import hzItemDetailsPop from './hzItemDetailsPop.vue';

/**
 * @description 河湖岛列表项
 * @example
 * <riverLakeIslandItem :data="data" @click="handleClick" />
 * @param {Object} data 事件数据
 * emit: click 点击事件回调
 */
export default {
    name: 'RiverLakeIslandItem',
    components: {
        hzItemDetailsPop,
    },
    props: {
        data: {
            type: Object,
            default: () => ({}),
        },
        activityId: {
            type: String | Number,
            default: 0,
        },
    },

    data() {
        return {
        };
    },
    computed: {},
    methods: {
        handleClick(data) {
            this.$emit('clickItemPositioning', data);
        },
    },
    mounted() {},
};
</script>

<style lang="scss" scoped>
.list-item {
    padding: 6px 8px;
    // background: #112d7b;
    border-radius: 2px 2px 2px 2px;
    border: 1px solid #1a47a4;
    font-size: 14px;
    line-height: 1.5;
    display: flex;
    margin-bottom: 5px;
    .item-info {
        flex: 1;
    }
    .item-icon {
        width: 20px;
    }
}
.activity {
    background:#49f0fd ;
}
</style>
<style lang="scss"></style>
